import { type IActivityCategory } from "@medoma/models/activities";
import styles from "./ActivityTag.module.scss";
import { Link } from "@medoma/components/Link/Link";
import { Heading } from "@medoma/components/Heading/Heading";
import { CategoryIcon } from "@/components/CategoryIcon/CategoryIcon";

type IActivityGroupTag = {
  category: IActivityCategory;
  title: string;
  patientId?: string;
};

export const ActivityTag = ({
  category,
  title,
  patientId,
}: IActivityGroupTag) => {
  const shouldLinkToPatient = Boolean(patientId);

  return (
    <div className={styles.iconAndTitle}>
      <CategoryIcon category={category} />
      {shouldLinkToPatient ? (
        <Heading level="h2" size="h3" className={styles.title}>
          <Link to={`/patients/${patientId}`}>{title}</Link>
        </Heading>
      ) : (
        <Heading level="h2" size="h3" className={styles.title}>
          {title}
        </Heading>
      )}
    </div>
  );
};
